import React, { useContext, useEffect, useState } from "react";
import "./CaFaeTable.scss";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import { Table } from "core/table/Table";
import moment from "moment";
import { MONTHS } from "constants/constants";
import InfoContext from "pages/InfoContext";
import TableDateNav from "components/table-date-nav/TableDateNav";

const CaFaeTable = () => {
  const {
    dashboardStats,
    caFaeSelectedYear,
    setCaFaeSelectedYear,
    userScope,
    setCaFaeSelectedDate,
    caFaeSelectedDate,
  } = useContext(InfoContext);
  const billingStats = dashboardStats?.billingStats;
  const { billed, to_bill } = billingStats || [];
  const [billedTableValues, setBilledTableValues] = useState([]);
  const [toBillTableValues, setToBillTableValues] = useState([]);

  useEffect(() => {
    if (billed && billed.length > 0) {
      setBilledTableValues(
        getStats(
          billed,
          billed[0].stats.map((e) => e.currency_symbol),
          { status: "billed" }
        )
      );
    }
  }, [billed]);

  useEffect(() => {
    if (to_bill && to_bill.length > 0) {
      setToBillTableValues(
        getStats(
          to_bill,
          to_bill
            .find((e) => e.stats?.length > 0)
            ?.stats.map((e) => e.currency_symbol),
          { status: "to-bill" }
        )
      );
    }
  }, [to_bill]);

  const rowHeader = {
    year: (
      <TableDateNav
        selectedDate={caFaeSelectedDate}
        setSelectedDate={setCaFaeSelectedDate}
        setSelectedYear={setCaFaeSelectedYear}
      />
    ),
    ca: (
      <Typography
        type="span"
        label={<FormattedMessage id="ca-billed" defaultMessage="CA facturé" />}
      />
    ),
    fae: (
      <Typography
        type="span"
        label={
          <FormattedMessage id="to-be-billed" defaultMessage="À facturer" />
        }
      />
    ),
  };

  const header = MONTHS.map((month, i) => {
    return {
      label: {
        key: month,
        value: (i + 1).toString().padStart(2, "0") + "/" + caFaeSelectedYear,
      },
      id: month,
    };
  });

  const getStats = (data, currencies, status) => {
    const getIndex = (el, currency) =>
      el.stats.findIndex((e) => {
        return currency === e.currency_symbol;
      }) || 0;
    if (data?.length > 0) {
      return currencies.map((currency) => {
        const currentStat = data.map((el) => {
          const index = getIndex(el, currency);
          if (index >= 0) {
            el.stats[index]["status"] = status.status;
            el.stats[index]["id"] = el.month;
            return el.stats[index];
          }
        });
        const formattedStat = currentStat.map((e, i) => {
          return {
            [moment().month(i).lang("en").format("MMMM").toLocaleLowerCase()]: e
              ? {
                  value: `${Math.ceil(e.value).toLocaleString("en-EN")} ${
                    e.currency_symbol
                  }`,
                  status: e.status,
                  id: e.id,
                }
              : {
                  value: null,
                  status: null,
                  id: null,
                },
          };
        });
        return Object.assign({}, ...formattedStat);
      });
    }
  };

  return (
    <>
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <>
            <FormattedMessage
              id="ca-and-fae-table-for-the-fiscal-year"
              defaultMessage={"TABLEAU DES CA ET FAE DE L'ANNÉE FISCALE"}
            />{" "}
            {caFaeSelectedYear}
          </>
        }
      />
      <div className="dashboard-CA-FAE-table-wrapper">
        <div>
          <div style={{ display: "flex" }}>
            <div className="table-left-part">
              <div>{rowHeader.year}</div>
              <div className="table-left-part_section">
                <div className="table-left-part_section_CA">{rowHeader.ca}</div>
              </div>
            </div>
            <Table
              userScope={userScope}
              id={"dashboard-CA-table"}
              header={header}
              content={billedTableValues}
              caFaeSelectedYear={caFaeSelectedYear}
              isDashboard={true}
            />
          </div>
          <div style={{ display: "flex" }}>
            <div className="table-left-part">
              <div className="table-left-part_section">
                <div className="table-left-part_section_FAE">
                  {rowHeader.fae}
                </div>
              </div>
            </div>
            <Table
              userScope={userScope}
              id={"dashboard-FAE-table"}
              header={[]}
              content={toBillTableValues}
              caFaeSelectedYear={caFaeSelectedYear}
              isDashboard={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CaFaeTable;
